import React from "react";

export default function Pedidosya()
{
    window.location.href="https://www.pedidosya.com.ar/restaurantes/lanus/baum-lanus-menu";
    return "";
                
}     